import React from "react";
import { View } from "@react-pdf/renderer";

export const Line = ({ style }) => {
  return (
    <View style={{ width: "100%", height: "1px", backgroundColor: "#0000001A", marginTop: 12, ...style }} />
  )
}
